import { type RpmPicks } from '@on3/api';
import { Avatar } from '@on3/ui-lib/components/Avatar';
import clsx from 'clsx';

import styles from './RpmNewLeader.module.scss';

export const RpmNewLeader = ({ pick }: { pick: RpmPicks }) => {
  const { topTeams = [] } = pick;

  return (
    <div className={styles.block}>
      {topTeams.map((team, i) => (
        <dl className={styles.team} key={team.key}>
          <dt>
            {team.organization?.name || team.organization?.fullName || 'Team'}
          </dt>
          <dd>
            <figure>
              <Avatar
                altText={`${team.organization?.name} avatar`}
                className={styles.avatar}
                domain={team.organization?.asset?.domain}
                height={20}
                source={team.organization?.asset?.source}
                teamAvatar
                width={20}
              />
            </figure>
            <div
              className={clsx(styles.rankContainer, {
                [styles.leader]: i === 0 && team.currentRank === 1,
              })}
            >
              <span>#{team.currentRank}</span>
              <span>({team.currentPercentage?.toFixed(0)}%)</span>
            </div>
          </dd>
        </dl>
      ))}
    </div>
  );
};
